<template>
    <label>
        <span :class="{'focused': focused || value || isMobile}" class="title">{{title}}</span>
        <flat-pickr
            :value="value"
            :config="{'enableTime': enableTime, 'time_24hr': true}"
            @on-change="changeHandler"
            @on-open="focused = true"
            @on-close="closeHandler"
        ></flat-pickr>
        <i
            v-if="!isMobile"
            class="material-icons clear"
            v-show="value.length > 0"
            @click.stop.prevent="clearClickHandler"
        >cancel</i>
    </label>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { getDateString } from '@/Helpers/HelperFunctions.js'
export default {
    components: {
        flatPickr,
    },
    created() {
        if( navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)) {
                this.isMobile = true
            }
    },
    props: {
        enableTime: Boolean,
        title: String,
        value: { type: [String, Date]},
    },
    data() {
        return {
            date: '1990-01-28',
            focused: false,
            isMobile: false,
        }
    },
    methods: {
        closeHandler() {
            if (!this.value) {
                this.focused = false
            }
        },
        changeHandler(date) {
            if (date.length == 0) return
            var string = ''
            if(this.enableTime) {
                if (date[0].getTime() == this.value.getTime()) return
                this.$emit('input', date[0])
                return
            }
            else {
                string = getDateString(date, 'yyyy-MM-dd')
            }
            if (string == this.value) return
            this.$emit('input', string)
        },
        clearClickHandler() {
            this.$emit('clear')
        },
    },
}
</script>

<style lang="scss" scoped>
$border-color: $green-main;
label {
    position: relative;
    display: inline-block;
    height: 40 * $rem;
    width: 197 * $rem;

    span.title {
        color: rgb(70, 70, 70);
        position: absolute;
        top: 10 * $rem;
        font-size: 15 * $rem;
        margin-left: 15 * $rem;
        transition: all 0.2s ease-out;
        background-color: white;
        white-space: nowrap;
        cursor: text;
        max-width: 190 * $rem;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;

        &.focused {
            top: -6 * $rem;
            font-size: 12 * $rem;
            color: $border-color;
            padding-left: 2 * $rem;
            padding-right: 2 * $rem;
            left: 0;
        }
    }

    .material-icons {
        font-size: 18 * $rem;
        position: absolute;
        right: 15 * $rem;
        top: 10 * $rem;

        &.error {
            color: rgb(175, 3, 3);
        }

        &.clear {
            cursor: pointer;
            color: #b4b4b4;
        }
    }

    .helper {
        position: absolute;
        top: 45 * $rem;
        left: 30 * $rem;
        font-size: 12 * $rem;
        color: #5c5c5c;
        width: calc(100% - 30 * #{$rem});
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        overflow: hidden;
    }

    .error-message {
        position: absolute;
        top: 43 * $rem;
        left: 15 * $rem;
        font-size: 12 * $rem;
        color: rgb(175, 3, 3);
        width: calc(100% - 15 * #{$rem});
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        overflow: hidden;
    }
}

.flatpickr-input {
    width: 100%;
    height: 40 * $rem;
    border-radius: 5 * $rem;
    box-shadow: none;
    border: 1 * $rem solid #b4b4b4;
    color: #474747;
    font-size: 15 * $rem;
    padding-left: 15 * $rem;
    outline: none;

    &:focus {
        border: 1 * $rem solid $border-color;
    }
}

/deep/ .flatpickr-mobile {
    width: 100%;
    height: 40 * $rem;
    border-radius: 5 * $rem;
    box-shadow: none;
    border: 1 * $rem solid #b4b4b4;
    color: #474747;
    font-size: 15 * $rem;
    padding-left: 15 * $rem;
    outline: none;
}

/deep/ input[type=date] {
    width: 100%;
    height: 100%;
    padding-left: 15 * $rem;
    font-size: 15 * $rem;
    border: 0.0625rem solid #b4b4b4;
    border-radius: 0.3125rem;
}

@media only screen and (max-width: 600px) {
    span.title {
        font-size: 15 * $rem !important;
    }
}
</style>